import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const OverwriteIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M6.42676 5C5.59833 5 4.92676 5.67157 4.92676 6.5V8.58579L8.51254 5H6.42676ZM11.2931 5C11.2503 5.07404 11.1972 5.14376 11.1339 5.20711L5.13386 11.2071C5.07052 11.2704 5.0008 11.3235 4.92676 11.3663V14.5C4.92676 14.528 4.92753 14.5559 4.92904 14.5835L14.5103 5.00229C14.4826 5.00077 14.4548 5 14.4268 5H11.2931ZM15.9245 6.4165L6.34326 15.9977C6.3709 15.9992 6.39874 16 6.42676 16H9.56045C9.60324 15.926 9.65631 15.8562 9.71965 15.7929L15.7197 9.79289C15.783 9.72955 15.8527 9.67648 15.9268 9.63369V6.5C15.9268 6.47198 15.926 6.44414 15.9245 6.4165ZM15.9268 12.4142L12.341 16H14.4268C15.2552 16 15.9268 15.3284 15.9268 14.5V12.4142ZM2.92676 6.5C2.92676 4.567 4.49376 3 6.42676 3H14.4268C16.3598 3 17.9268 4.567 17.9268 6.5V14.5C17.9268 16.433 16.3598 18 14.4268 18H6.42676C4.49376 18 2.92676 16.433 2.92676 14.5V6.5ZM19.9268 6C20.479 6 20.9268 6.44772 20.9268 7V17.5C20.9268 19.433 19.3598 21 17.4268 21H6.92676C6.37447 21 5.92676 20.5523 5.92676 20C5.92676 19.4477 6.37447 19 6.92676 19H17.4268C18.2552 19 18.9268 18.3284 18.9268 17.5V7C18.9268 6.44772 19.3745 6 19.9268 6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

OverwriteIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(OverwriteIcon);
